import React from "react";

export default function GroundVehicleMFS(props) {
  return (
    <div className="groundVehicleMFS">
      <p>
        By grounding this vehicle, dealer will have multiple purchase options
        and customer will be invoiced asa lease return.
      </p>
    </div>
  );
}
